export const SET_PAGE_NAME = "shared/UTF/SET_PAGE_NAME";
